import { BaseController } from "./_BaseController";
import { TypedMatNode } from "../_Base";
import { NodeParamsConfig, ParamConfig } from "../../utils/params/ParamsConfig";
import { isBooleanTrue } from "../../../../core/BooleanValue";
import { MeshBasicMaterial } from "three";
var LineCapType = /* @__PURE__ */ ((LineCapType2) => {
  LineCapType2["ROUND"] = "round";
  LineCapType2["BUTT"] = "butt";
  LineCapType2["SQUARE"] = "square";
  return LineCapType2;
})(LineCapType || {});
const LINE_CAP_TYPES = ["round" /* ROUND */, "butt" /* BUTT */, "square" /* SQUARE */];
var LineJoinType = /* @__PURE__ */ ((LineJoinType2) => {
  LineJoinType2["ROUND"] = "round";
  LineJoinType2["BEVEL"] = "bevel";
  LineJoinType2["MITER"] = "miter";
  return LineJoinType2;
})(LineJoinType || {});
const LINE_JOIN_TYPES = ["round" /* ROUND */, "bevel" /* BEVEL */, "miter" /* MITER */];
export function WireframeParamConfig(Base) {
  return class Mixin extends Base {
    constructor() {
      super(...arguments);
      this.wireframe = ParamConfig.BOOLEAN(0, { separatorBefore: true });
      this.wireframeLinecap = ParamConfig.INTEGER(0, {
        menu: {
          entries: LINE_CAP_TYPES.map((name, value) => {
            return { name, value };
          })
        },
        visibleIf: { wireframe: 1 }
      });
      this.wireframeLinejoin = ParamConfig.INTEGER(0, {
        menu: {
          entries: LINE_JOIN_TYPES.map((name, value) => {
            return { name, value };
          })
        },
        visibleIf: { wireframe: 1 }
      });
    }
  };
}
class WireframeParamsConfig extends WireframeParamConfig(NodeParamsConfig) {
}
class WireframedMatNode extends TypedMatNode {
  createMaterial() {
    return new MeshBasicMaterial();
  }
}
export class WireframeController extends BaseController {
  constructor(node) {
    super(node);
    this.node = node;
  }
  static update(node) {
    const material = node.material;
    const pv = node.pv;
    material.wireframe = isBooleanTrue(pv.wireframe);
    material.wireframeLinecap = LINE_CAP_TYPES[pv.wireframeLinecap];
    material.wireframeLinejoin = LINE_JOIN_TYPES[pv.wireframeLinejoin];
    material.needsUpdate = true;
  }
}
